// Make functions global so your inline click handlers can call them
window.getSelectedBundleQty = function getSelectedBundleQty() {
  const activeCard = document.querySelector('.quantity-wrapper .option-card.active');
  const qtyEl = activeCard?.querySelector('.option-qty');
  const qty = parseInt(qtyEl?.textContent?.trim() || '0', 10);
  return Number.isFinite(qty) && qty > 0 ? qty : 0;
};

window.buildBundleRows = function buildBundleRows() {
  const modal = document.getElementById('quantity-modal');
  if (!modal) return;

  const rowsWrap = modal.querySelector('.bundle-rows');
  const template = modal.querySelector('#bundle-swatch-template');

  if (!rowsWrap || !template) return;

  const qty = window.getSelectedBundleQty();
  rowsWrap.innerHTML = '';

  // If qty isn't selected yet, keep button disabled
  if (!qty) {
    window.validateBundleSelection?.();
    return;
  }

  // Create 1 row per tee in the bundle (qty rows)
  for (let i = 1; i <= qty; i++) {
    const row = document.createElement('div');
    row.className = 'bundle-row';
    row.dataset.rowIndex = String(i);

    // Optional label (remove if you don't want it)
    const label = document.createElement('div');
    label.className = 'bundle-row__label h6';
    
    const bundleProductType = modal.dataset.bundleProductType || 'Item';
    label.textContent = `${bundleProductType} ${i}`;

    // Clone the swatch HTML from the <template>
    const swatches = template.content.cloneNode(true);

    row.appendChild(label);
    row.appendChild(swatches);
    rowsWrap.appendChild(row);
  }

  // After rebuilding rows, re-check validity
  window.validateBundleSelection?.();
};

window.validateBundleSelection = function validateBundleSelection() {
  const modal = document.getElementById('quantity-modal');
  if (!modal) return false;

  const confirmBtn = modal.querySelector('.bundle-confirm');
  const rows = modal.querySelectorAll('.bundle-row');

  if (!confirmBtn) return false;

  // No rows => can't confirm
  if (!rows.length) {
    confirmBtn.disabled = true;
    confirmBtn.setAttribute('aria-disabled', 'true');
    return false;
  }

  let allSelected = true;
  const selections = [];

  rows.forEach((row, idx) => {
    // Accept either .is-selected OR aria-pressed=true
    const selected =
      row.querySelector('.bundle-swatch.is-selected') ||
      row.querySelector('.bundle-swatch[aria-pressed="true"]');

    if (!selected) allSelected = false;

    // Try common places swatches store the value
    const value =
      selected?.dataset?.value ||
      selected?.getAttribute('data-value') ||
      selected?.getAttribute('data-swatch-value') ||
      selected?.getAttribute('aria-label') ||
      '';

    selections.push({ row: idx + 1, value });
  });

  confirmBtn.disabled = !allSelected;
  confirmBtn.setAttribute('aria-disabled', String(!allSelected));

  // Store selections on the modal for later use (optional)
  modal.dataset.bundleSelections = JSON.stringify(selections);

  return allSelected;
};

document.addEventListener('DOMContentLoaded', () => {
    const optionCards = document.querySelectorAll('.option-card');

    optionCards.forEach(card => {
        card.addEventListener('click', () => {
            optionCards.forEach(c => c.classList.remove('active'));
            card.classList.add('active');
            window.buildBundleRows?.();

            const qty = window.getSelectedBundleQty?.() || 0;

            if (qty === 2 || qty === 3) {
                const modal = document.getElementById('quantity-modal');

                requestAnimationFrame(() => {
                    if (typeof modal?.show === 'function') {
                        modal.show();
                    } else {
                        //console.warn('Modal not ready yet', modal);
                    }

                    window.filterBundleSwatchesBySize?.();
                });
            }
            });
    });

    document.addEventListener('click', e => {
        const swatch = e.target.closest('.bundle-swatch');
        if (!swatch) return;

        const row = swatch.closest('.bundle-row');
        if (!row) return;

        row.querySelectorAll('.bundle-swatch').forEach(s => {
            s.classList.remove('is-selected');
            s.setAttribute('aria-pressed', 'false');
        });

        swatch.classList.add('is-selected');
        swatch.setAttribute('aria-pressed', 'true');
        
        window.validateBundleSelection?.();
    });
});

window.getSelectedSize = function getSelectedSize() {
  const sizeFieldset = Array.from(document.querySelectorAll('fieldset.variant-picker__option'))
    .find(fs => {
      const legend = (fs.querySelector('legend')?.textContent || '').toLowerCase();
      return legend.includes('size'); // matches "AU Sizes"
    });

  const checked = sizeFieldset?.querySelector('input[type="radio"][name^="option"]:checked');

  const fallbackChecked = document.querySelector('input[type="radio"][name^="option"]:checked');

  return (checked?.value || fallbackChecked?.value || '').trim();
};

window.filterBundleSwatchesBySize = function filterBundleSwatchesBySize() {
  const modal = document.getElementById('quantity-modal');
  if (!modal) return;

  const size = window.getSelectedSize(); // e.g. "M"
  const wraps = modal.querySelectorAll('.bundle-swatch-wrap');

  wraps.forEach(wrap => {
    let map = {};
    try { map = JSON.parse(wrap.getAttribute('data-variant-map') || '{}'); } catch(e) {}

    // If size not chosen, show all (or you can hide all until chosen)
    if (!size) {
      wrap.style.display = '';
      return;
    }

    const entry = map[size];

    // Hide colours not available in the chosen size
    if (!entry || entry.available !== true) {
      wrap.style.display = 'none';

      // If hidden swatch was selected, unselect it
      const sw = wrap.querySelector('.bundle-swatch');
      if (sw?.classList.contains('is-selected')) {
        sw.classList.remove('is-selected');
        sw.setAttribute('aria-pressed', 'false');
      }
      return;
    }

    // Show and attach the correct variant ID for Add-to-cart
    wrap.style.display = '';
    const sw = wrap.querySelector('.bundle-swatch');
    if (sw) sw.dataset.variantId = entry.id;
  });

  window.validateBundleSelection?.();
};
const setButtonLoading = (btn, isLoading) => {
  if (!btn) return;

  btn.disabled = isLoading;
  btn.setAttribute('aria-busy', String(isLoading));

  const text = btn.querySelector('.btn-text');
  if (text) {
    text.textContent = isLoading ? '' : 'Add to cart';
  }
};

document.addEventListener('click', async (e) => {
  const btn = e.target.closest('.bundle-confirm');
  if (!btn) return;

  const modal = document.getElementById('quantity-modal');
  if (!modal) return;

  // Final validation
  if (!window.validateBundleSelection()) return;

  setButtonLoading(btn, true);
  btn.disabled = true;
  btn.setAttribute('aria-busy', 'true');

  // Collect selected variant IDs
  const selectedSwatches = modal.querySelectorAll(
    '.bundle-swatch.is-selected'
  );

  const items = Array.from(selectedSwatches)
    .map(sw => ({
      id: Number(sw.dataset.variantId),
      quantity: 1
    }))
    .filter(item => item.id);

  if (!items.length) return;

    document.documentElement.dispatchEvent(new CustomEvent("theme:loading:start", { bubbles: true }));
    const sectionsToBundle = [];
    document.documentElement.dispatchEvent(
    new CustomEvent('cart:prepare-bundled-sections', {
        bubbles: true,
        detail: { sections: sectionsToBundle }
    })
    );

    const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
    method: 'POST',
    headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
    },
    body: JSON.stringify({
        items,
        sections: sectionsToBundle
    })
    });


    const responseJson = await response.json();

    if (!response.ok) {
      const errorEl = document.querySelector('.bundle-error');
      console.log('errorEl', errorEl);

      if (errorEl) {
        errorEl.textContent =
          responseJson.description ||
          responseJson.message ||
          'Unable to add items to cart';

        errorEl.style.display = 'block';
      }

      setButtonLoading(btn, false);
      return;
    }

    document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));

    const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
    cartContent.sections = responseJson.sections;

    document.documentElement.dispatchEvent(
    new CustomEvent('variant:add', {
        bubbles: true,
        detail: {
        items: responseJson.items,
        cart: cartContent
        }
    })
    );

    document.documentElement.dispatchEvent(
    new CustomEvent('cart:change', {
        bubbles: true,
        detail: {
        baseEvent: 'variant:add',
        cart: cartContent
        }
    })
    );

  modal.hide();

  btn.disabled = false;
  btn.removeAttribute('aria-busy');
  const text = btn.querySelector('.btn-text');
  if (text) {
    text.textContent = 'Add to cart';
  }
});